export default class ProductApi {
    static apiBase = '/api/shop/';

    static getProduct({siteId, identifier}) {
        return fetch(this.apiBase + 'product/' + siteId + '/' + identifier);
    }
}